module.exports = __webpack_public_path__ + "static/media/pending-booking-icon.4d00d975.svg";